import { useParams } from "react-router-dom";
import { ClientDetails as ClientDetailsComponent } from "@/components/admin/client-details/ClientDetails";

const ClientDetails = () => {
  const { id } = useParams();

  if (!id) {
    return <div>Client ID not found</div>;
  }

  return <ClientDetailsComponent />;
};

export default ClientDetails;